export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看订单',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_audit') || '审核通过',
    icon: 'el-icon-check',
    menuType: 'audit',
    divided: true,
    allow: 'C',
    disabled: ({ backoutRequestStatus }) => !['S'].includes(backoutRequestStatus),
  },
  {
    text: that.$l('menu_text_reject') || '审核驳回',
    icon: 'el-icon-refresh-left',
    menuType: 'reject',
    divided: true,
    allow: 'R',
    disabled: ({ backoutRequestStatus }) => !['S'].includes(backoutRequestStatus),
  },
]
